import { render, staticRenderFns } from "./WelcomeFooter.vue?vue&type=template&id=59ef3fa3&scoped=true&"
import script from "./WelcomeFooter.vue?vue&type=script&lang=js&"
export * from "./WelcomeFooter.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeFooter.vue?vue&type=style&index=0&id=59ef3fa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ef3fa3",
  null
  
)

export default component.exports